var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseComponent } from '../base/base.component';
export var HeadingType;
(function (HeadingType) {
    HeadingType["H1"] = "h1";
    HeadingType["H2"] = "h2";
    HeadingType["H3"] = "h3";
    HeadingType["H4"] = "h4";
    HeadingType["H5"] = "h5";
    HeadingType["H6"] = "h6";
})(HeadingType || (HeadingType = {}));
export var HeadingSize;
(function (HeadingSize) {
    HeadingSize["XSMALL"] = "heading3";
    HeadingSize["SMALL"] = "heading2";
    HeadingSize["MID"] = "heading1";
    HeadingSize["LARGE"] = "hero-compact";
    HeadingSize["XLARGE"] = "hero";
})(HeadingSize || (HeadingSize = {}));
export var HeadingColor;
(function (HeadingColor) {
    HeadingColor["DARK"] = "dark";
    HeadingColor["MID"] = "mid";
    HeadingColor["LIGHT"] = "light";
})(HeadingColor || (HeadingColor = {}));
export var HeadingWeight;
(function (HeadingWeight) {
    HeadingWeight["BOLD"] = "bold";
    HeadingWeight["NORMAL"] = "normal";
})(HeadingWeight || (HeadingWeight = {}));
var HeadingComponent = /** @class */ (function (_super) {
    __extends(HeadingComponent, _super);
    function HeadingComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.HeadingType = HeadingType;
        _this.HeadingSize = HeadingSize;
        _this.HeadingColor = HeadingColor;
        _this.color = HeadingColor.DARK;
        _this.weight = HeadingWeight.BOLD;
        return _this;
    }
    return HeadingComponent;
}(BaseComponent));
export { HeadingComponent };



// WEBPACK FOOTER //
// ./src/@freelancer/ui/heading/heading.component.ts.pre-build-optimizer.js